import { Table as TanStackTable } from "@tanstack/react-table";
import { FilterableFields, createContext } from "@utils";
import { TFunction } from "i18next";
import { MutableRefObject } from "react";

export type SelectionIntent = "row" | "all";

export interface TableContextType<T = unknown> {
  tableId: string;
  t: TFunction<"translation", undefined>;
  table: TanStackTable<T>;
  sortableFields?: string[];
  filterableFields?: FilterableFields;
  baseFieldLabelTranslations?: string;
  editMode?: boolean;
  setEditMode?: (newEditMode: boolean) => void;
  columnWidths: Record<string, number>;
  onColumnResize: (columnId: string, width: number) => void;
  selectionIntent?: MutableRefObject<SelectionIntent | null>;
}

const { Provider: TableContextProvider, useContext: useTableContext } =
  createContext<TableContextType>();

export { TableContextProvider, useTableContext };
